/* Loop 2 R4: quote drawer resilience (snippets/quote-drawer.liquid). Loaded after assets/imm.js.
   - Keeps name, email, company, country and note in localStorage (imm_qd_form) through reloads, failed or held
     submits and the hCaptcha challenge page; cleared only after a successful post (?contact_posted=true).
   - Inline validation (required email, email format) with messages tied to the field (aria-invalid/aria-describedby).
   - Non-blocking hint when a personal mailbox is used. Opens the drawer when Shopify returns form errors. */
(function () {
  var qd = document.querySelector('[data-imm-qd]');
  var form = qd && qd.querySelector('[data-imm-qform]');
  if (!form) return;
  var KEY = 'imm_qd_form';
  var FIELDS = ['contact[name]', 'contact[email]', 'contact[company]', 'contact[country]', 'contact[certificate]', 'contact[po_reference]', 'contact[required_by]', 'contact[body]'];
  // consumer mailboxes only, whole domain anchored (mail.mil, live.unc.edu, mail.acme.com are not flagged)
  var FREE = /@(gmail\.com|googlemail\.com|yahoo\.[a-z]{2,3}(\.[a-z]{2})?|ymail\.com|hotmail\.[a-z]{2,3}(\.[a-z]{2})?|outlook\.com|live\.com|msn\.com|icloud\.com|me\.com|aol\.com|proton\.me|protonmail\.com|pm\.me|gmx\.(com|net|de|at|ch)|mail\.com|yandex\.(com|ru)|qq\.com|163\.com|126\.com)$/i;
  window.immFreeMail = FREE;
  var EMAIL = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
  var email = form.querySelector('[name="contact[email]"]');

  function field(n) { return form.querySelector('[name="' + n + '"]'); }
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function store() {
    var o = {};
    FIELDS.forEach(function (n) { var f = field(n); if (f && f.value) o[n] = f.value.slice(0, 4000); });
    try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {}
  }

  // after a successful post: forget the saved fields (imm.js clears the list itself)
  // submitter of this post / these errors comes from the R10b block in assets/imm.js (another form's post must not clear it)
  var mine = window.immQuoteSent === true;
  var posted = window.immPostedBy === 'list' && !!qd.querySelector('[data-imm-qsent]');
  if (posted) { try { localStorage.removeItem(KEY); } catch (e) {} }
  else {
    var saved = read();
    FIELDS.forEach(function (n) { var f = field(n); if (f && saved[n] && (!f.value || f.tagName === 'SELECT') && f.value !== saved[n]) f.value = saved[n]; });
  }

  function msgEl(f) {
    var id = f.id + '-err', m = document.getElementById(id);
    if (!m) {
      m = document.createElement('p'); m.id = id; m.className = 'imm-qdv__err'; m.setAttribute('role', 'alert');
      f.parentNode.appendChild(m);
      f.setAttribute('aria-describedby', ((f.getAttribute('aria-describedby') || '') + ' ' + id).trim());
    }
    return m;
  }
  function hintEl() {
    var m = document.getElementById('ql-email-hint');
    if (!m) {
      m = document.createElement('p'); m.id = 'ql-email-hint'; m.className = 'imm-qdv__hint'; m.setAttribute('aria-live', 'polite');
      email.parentNode.appendChild(m);
      email.setAttribute('aria-describedby', ((email.getAttribute('aria-describedby') || '') + ' ql-email-hint').trim());
    }
    return m;
  }
  function checkEmail(strict) {
    var v = email.value.trim(), err = '';
    if (!v) err = strict ? 'Enter your email so we can send the quote.' : '';
    else if (!EMAIL.test(v)) err = 'This email looks incomplete, for example name@company.com.';
    var m = msgEl(email);
    m.textContent = err; m.hidden = !err;
    email.setAttribute('aria-invalid', err ? 'true' : 'false');
    var h = hintEl();
    var free = !err && FREE.test(v);
    h.textContent = free ? 'Tip: a company email lets us address the quote and proforma invoice to your organisation. Personal email works too.' : '';
    h.hidden = !free;
    return !err;
  }

  form.noValidate = true;   // own messages instead of the browser bubble
  form.addEventListener('input', function (e) {
    store();
    if (e.target === email && email.getAttribute('aria-invalid') === 'true') checkEmail(false);
  });
  form.addEventListener('change', store);
  email.addEventListener('blur', function () { if (email.value.trim()) checkEmail(false); });
  // capture phase: runs before the imm.js submit handler, so an invalid form never fills contact[items] or the sent flag
  // R10b: "Required by" cannot be in the past (noValidate switches off the browser's min check)
  var due = field('contact[required_by]');
  function checkDue() {
    if (!due) return true;
    var d = new Date(), t = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    var err = due.value && due.value < t ? 'This date has passed. Pick today or a later date, or leave it empty.' : '';
    var m = msgEl(due); m.textContent = err; m.hidden = !err;
    due.setAttribute('aria-invalid', err ? 'true' : 'false');
    return !err;
  }
  if (due) due.addEventListener('change', checkDue);
  form.addEventListener('submit', function (e) {
    store();
    var okMail = checkEmail(true), okDue = checkDue();
    if (!okMail || !okDue) { e.preventDefault(); e.stopImmediatePropagation(); (okMail ? due : email).focus(); }
  }, true);

  // Shopify re-rendered the page with form errors (or the challenge sent the buyer back): show the drawer again
  if (mine && qd.querySelector('.imm-alert--err')) {
    var opener = document.querySelector('[data-imm-qopen]');
    if (opener) setTimeout(function () { opener.click(); }, 60);
  }
})();
